import { createComponent, ComponentProps } from '@/internals/utils';

export type SidenavFooterProps = ComponentProps;

/**
 * The `Sidenav.Footer` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
const SidenavFooter = createComponent<'div', SidenavFooterProps>({ name: 'SidenavFooter' });

export default SidenavFooter;
